import Phaser from 'phaser';
import { BaseEnemy, ALL_DIRS, Direction, GridQuery, reverseOf } from './BaseEnemy';

export class Wanderer extends BaseEnemy {
  private lastDecisionCell = '';

  constructor(scene: Phaser.Scene, col: number, row: number, grid: GridQuery) {
    super(scene, 'enemy-wanderer', col, row, 0.6, grid);
    const start = Phaser.Utils.Array.GetRandom(ALL_DIRS) as Direction;
    this.applyDir(start);
  }

  update(_time: number, _delta: number) {
    if (!this.alive) return;
    this.animateWalk(_delta);

    // Decide only when centered on a NEW tile (one decision per tile crossed).
    if (!this.isCenteredOnTile(6)) return;

    const { col, row } = this.centerOfTile();
    const cellKey = `${col},${row}`;
    if (cellKey === this.lastDecisionCell) return;
    this.lastDecisionCell = cellKey;

    const canContinue = this.canMoveTo(this.currentDir);
    if (canContinue) {
      // Predictable: keep going straight unless blocked.
      this.applyDir(this.currentDir);
      return;
    }

    // Blocked — pick a new direction. Prefer non-reverse so we don't bounce in place.
    const options = ALL_DIRS.filter(d => this.canMoveTo(d));
    if (options.length === 0) {
      (this.body as Phaser.Physics.Arcade.Body).setVelocity(0, 0);
      return;
    }
    const rev = reverseOf(this.currentDir);
    const nonReverse = options.filter(d => d !== rev);
    const choice = (nonReverse.length > 0 ? nonReverse : options);
    this.applyDir(Phaser.Utils.Array.GetRandom(choice) as Direction);
  }
}
